<template>
<div>
  <div class="page-header">
    <div class="page-leftheader">
      <!-- <div class="headline"><h4 class="page-title text-primary">Benutzer</h4 ></div> -->
      <v-tabs v-model="userTab">
            <v-tab href="#tab-1">
              <div class="page-leftheader">
                <div class="headline">
                  <h4 class="page-title text-primary">Benutzer</h4>
                </div>
              </div>
            </v-tab>

            <v-tab href="#tab-2" @click="handleTabChange('#tab-2')">
              <div class="page-leftheader">
                <div class="headline">
                  <h4 class="page-title text-primary">Map</h4>
                </div>
              </div>
            </v-tab>
          </v-tabs>

    </div>
    <div class="page-rightheader">
      <a
          class="btn btn-primary btn-pill mr-1"
          @click="$router.push('blacklisted')"
          >Gesperrte Nutzer</a
        >
      <a class="btn btn-primary btn-pill d-none" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
                    <div class="dropdown-menu border-0">
                            <a class="dropdown-item" id="dropdownToday" @click="setTimePicker('Today')">Letzte 24 Stunden</a>
                            <a class="dropdown-item" id="dropdownLastWeek" @click="setTimePicker('LastWeek')">Letzte 7 Tage</a>
                            <a class="dropdown-item" id="dropdownLastMonth" @click="setTimePicker('LastMonth')">Letzte 30 Tage</a>
                            <a class="dropdown-item active" id="dropdownAllTime" @click="setTimePicker('AllTime')">Gesamt</a>
                    </div>
    </div>
    
  </div>
  <div>
    <v-tabs-items v-model="userTab">
    <v-tab-item :value="'tab-1'">
      <div>
        <input v-model="search" type="search" class="form-control form-control-sm" placeholder="Suche..." aria-controls="example1">
        <!--
          WAR FALSCH: Nirgends stand, dass diese Liste ausschließlich aktive
          Konten zeigt. Der Server filtert hart auf status = ACTIVE
          (ETSBackend/controllers/v1/userController.js, allUsersSortedWithLimit
          und searchUserAsAdmin) — ein gesperrtes Konto ist damit weder in der
          Liste noch über die Suche zu finden. Wer eben jemanden gesperrt hat,
          sah die Zeile einfach verschwinden, ohne Hinweis wohin. Und wer ein
          gesperrtes Konto suchte, bekam eine leere Trefferliste und musste
          daraus schließen, das Konto sei gelöscht. Der Satz sagt beides jetzt
          ausdrücklich und nennt den Weg dorthin.
        -->
        <small class="text-muted d-block mt-1 mb-2">
          Diese Liste zeigt nur aktive Konten — auch die Suche. Gesperrte Konten
          stehen unter „Gesperrte Nutzer“ (Knopf oben rechts) und werden dort
          auch wieder freigeschaltet.
        </small>
    </div>
    <div>
      <div>
        <div class="card">
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap">
              <thead>
                <tr>
                  <th>Profilbild</th>
                  <!--
                    WAR FALSCH: Ein Klick sortierte zwar korrekt (order steuert
                    orderReq für den Server), aber die beiden Pfeile darunter
                    zeigten dabei genau verkehrt herum. order=true bedeutet
                    orderReq='1' = aufsteigend (A-Z) — vorher stand dabei der
                    Pfeil nach UNTEN (fe-chevron-down), absteigend (Z-A) der
                    Pfeil nach OBEN. Das ist der gängigen Lesart entgegengesetzt
                    (aufsteigend = Pfeil nach oben) und ließ die Liste "falsch
                    sortiert" wirken, obwohl sie es nicht war. Jetzt zeigt
                    aufsteigend nach oben, absteigend nach unten — an allen
                    sechs Spalten gleich.
                  -->
                  <th @click="sort = 'userName', order = !order,order ? orderReq = '1' : orderReq = '-1',search == '' ? fetchUser() : searchUser()">Benutzername<i v-if="sort == 'userName' && order" class="fe fe-chevron-up"></i><i v-if="sort == 'userName' && !order" class="fe fe-chevron-down"></i></th>
                  <th @click="sort = 'email', order = !order,order ? orderReq = '1' : orderReq = '-1', search == '' ? fetchUser() : searchUser()">E-Mail<i v-if="sort == 'email' && order" class="fe fe-chevron-up"></i><i v-if="sort == 'email' && !order" class="fe fe-chevron-down"></i></th>
                  <th class="text-end" @click="sort = 'points', order = !order, order ? orderReq = '1' : orderReq = '-1', search == '' ? fetchUser() : searchUser()" style="cursor:pointer" title="Punkte aus Kilometern, Beiträgen, Kommentaren, Treffen und Werbung">Punkte<i v-if="sort == 'points' && order" class="fe fe-chevron-up"></i><i v-if="sort == 'points' && !order" class="fe fe-chevron-down"></i></th>
                  <th class="text-end" @click="sort = 'kilometers', order = !order, order ? orderReq = '1' : orderReq = '-1', search == '' ? fetchUser() : searchUser()" style="cursor:pointer">km<i v-if="sort == 'kilometers' && order" class="fe fe-chevron-up"></i><i v-if="sort == 'kilometers' && !order" class="fe fe-chevron-down"></i></th>
                  <th class="text-end" @click="sort = 'posts', order = !order, order ? orderReq = '1' : orderReq = '-1', search == '' ? fetchUser() : searchUser()" style="cursor:pointer">Beiträge<i v-if="sort == 'posts' && order" class="fe fe-chevron-up"></i><i v-if="sort == 'posts' && !order" class="fe fe-chevron-down"></i></th>
                  <th @click="sort = 'createdAt', order = !order,order ? orderReq = '1' : orderReq = '-1', search == '' ? fetchUser() : searchUser()">Anmeldedatum<i v-if="sort == 'createdAt' && order" class="fe fe-chevron-up"></i><i v-if="sort == 'createdAt' && !order" class="fe fe-chevron-down"></i></th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
              <!--
                Vier Zustände in EINER Kette (v-if / v-else-if / v-else):
                lädt · Abruf gescheitert · nichts gefunden · Ergebnisse.

                WAR FALSCH (Runde 1): Es gab nur "ist die Liste leer?" — das
                trifft VOR der Antwort genauso zu wie NACH einem Fehlschlag.
                "Keine Benutzer gefunden." stand deshalb kurz beim Öffnen der
                Seite da und blieb bei einem gescheiterten Abruf dauerhaft
                stehen, obwohl gar nicht gesucht werden konnte.

                WAR FALSCH (Runde 2): Die Zustandszeilen bildeten zwar eine
                Kette, die Datenzeilen standen aber DANEBEN und wurden immer
                gezeichnet. Scheiterte ein Abruf (Klick auf einen Spaltenkopf,
                Zeitraumfilter), stand oben die rote Fehlerzeile und darunter
                unverändert die komplette Liste des letzten geglückten Abrufs —
                der Bildschirm sagte beides gleichzeitig. Wer die schmale rote
                Zeile übersah, hielt die veraltete Liste für das Ergebnis seiner
                Sortierung. Jetzt hängen die Datenzeilen als v-else an derselben
                Kette. Beim bloßen Nachladen (loading, Liste noch gefüllt)
                bleiben sie stehen — das ist gewollt und verhindert Flackern.

                WICHTIG für spätere Änderungen: Zwischen die Glieder dieser
                Kette gehört KEIN Kommentar und kein Text. Vue verbindet
                v-else-if/v-else nur mit dem unmittelbar davorstehenden
                Geschwisterelement; ein Kommentar dazwischen trennt die Kette,
                sobald der Übersetzer mit `comments: true` läuft (nachgemessen
                mit vue-template-compiler: "text ... between v-if and
                v-else(-if) will be ignored"). Erklärungen deshalb hierher,
                oberhalb der Kette.
              -->
              <tr v-if="loading && users.length === 0">
                <td colspan="8" class="text-center text-muted">Wird geladen …</td>
              </tr>
              <tr v-else-if="fetchError">
                <td colspan="8" class="text-center text-danger">{{ fetchError }}</td>
              </tr>
              <tr v-else-if="users.length === 0">
                <td colspan="8" class="text-center text-muted">Keine Benutzer gefunden.</td>
              </tr>
              <template v-else>
              <tr v-for="user in users" :key="user._id">
                <td class="align-middle">
                  <img :src="`${$img(user.image,$awsSmallImages)}`" alt="img" class="avatar avatar-md brround">
                </td>
                <td class="align-middle">
                  {{user.userName}}
                  <!--
                    WAR FALSCH: Hier stand eine Dreier-Kette anonym / gesperrt /
                    aktiv. Zwei Fehler auf einmal:

                    1. Das grüne „aktiv" erschien hinter JEDEM Namen und sagte
                       damit nichts aus — der Server liefert in diese Liste
                       ausschließlich aktive Konten (status = ACTIVE). Schlimmer
                       als nur Rauschen: Es erweckte den Eindruck, die Liste
                       unterscheide die Zustände, es gebe hier also auch
                       gesperrte Konten zu sehen. Genau deshalb suchte der
                       Verwalter ein gesperrtes Konto hier statt auf der Seite
                       „Gesperrte Nutzer“. Der Hinweis über der Tabelle sagt
                       jetzt geradeheraus, was die Liste enthält.
                    2. Die Kette (v-else-if/v-else) konnte immer nur EIN
                       Abzeichen zeigen. Ein anonymes UND gesperrtes Konto wäre
                       nur als „anonym" erschienen. Beide Angaben sind jetzt
                       unabhängig voneinander.

                    Das rote „gesperrt" bleibt bewusst stehen, obwohl es
                    derzeit nie erscheinen kann: Der ACTIVE-Filter im Backend
                    steht selbst auf der Fehlerliste. Fällt er, zeigt diese
                    Zeile ohne weiteres Zutun das Richtige — würde man sie
                    jetzt entfernen, entstünde in genau dem Moment ein neuer
                    Fehler (gesperrte Konten unmarkiert zwischen aktiven).
                  -->
                  <span v-if="user.isAnonymous" class="badge bg-secondary ms-2">anonym</span>
                  <span v-if="user.status !== 1" class="badge bg-danger ms-2">gesperrt</span>
                </td>
                <td class="align-middle">{{user.email}}</td>
                <td class="align-middle text-end"><b>{{user.points}}</b></td>
                <td class="align-middle text-end">{{user.kilometers}}</td>
                <td class="align-middle text-end">{{user.posts}}</td>
                <td class="align-middle">{{convertDateToString(user.createdAt)}}</td>
                <td class="align-middle">
                  <!-- Vier Knöpfe je Zeile machten die Tabelle unruhig — jetzt gebündelt -->
                  <div class="dropdown">
                    <a class="btn btn-sm btn-primary" data-bs-toggle="dropdown" aria-expanded="false" title="Aktionen">
                      <i class="fas fa-ellipsis-h"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a class="dropdown-item" @click="openEditUser(user)"><i class="fas fa-edit me-2"></i>Bearbeiten</a>
                      <a class="dropdown-item" @click="fetchUserCars(user)"><i class="fas fa-car me-2"></i>Fahrzeuge</a>
                      <div class="dropdown-divider"></div>
                      <!--
                        Zeigte bisher immer "Sperren", unabhängig vom Kontostatus.
                        Jetzt an denselben user.status gekoppelt wie das Abzeichen
                        oben.

                        RICHTIGSTELLUNG zum früheren Kommentar an dieser Stelle:
                        Dort stand, ein bereits gesperrtes Konto habe sich "von
                        hier aus nicht entsperren" lassen — das klang, als sei
                        damit ein Weg wiederhergestellt worden, den es vorher
                        nicht gab. Das stimmt nicht. Der Server liefert in diese
                        Liste ausschließlich aktive Konten (ACTIVE-Filter, siehe
                        Hinweis über der Tabelle), deshalb ist user.status hier
                        IMMER 1 — "Entsperren" erscheint nie. Nachgemessen am
                        QA-Server: GET /user/all/0/25/-1/null/-1 liefert 25
                        Zeilen, vorkommende Statuswerte {1}; ein zuvor gesperrtes
                        Konto war weder darin noch über /user/admin/search zu
                        finden.

                        Der Zweig bleibt trotzdem stehen: Der ACTIVE-Filter im
                        Backend steht selbst auf der Fehlerliste. Fällt er, ist
                        diese Zeile sofort richtig und nötig. Entsperren geht
                        währenddessen vollständig über die Seite "Gesperrte
                        Nutzer" — dort ist es der einzige und richtige Weg.
                      -->
                      <a v-if="user.status === 1" class="dropdown-item text-danger" @click="openBanUser(user)"><i class="fas fa-ban me-2"></i>Sperren</a>
                      <a v-else class="dropdown-item" @click="openUnbanUser(user)"><i class="fas fa-unlock me-2"></i>Entsperren</a>
                      <a class="dropdown-item text-danger" @click="openDeleteUser(user)"><i class="fas fa-trash-alt me-2"></i>Löschen</a>
                    </div>
                  </div>
                </td>

              </tr>
              </template>
            </tbody>
            </table>
          </div>
        </div>
        <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      </div>
      </div>
    </v-tab-item>
    <v-tab-item :value="'tab-2'">
      <div>
        <GmapMap
        :center="center"
        :zoom="4"
        style="width: 100%; height: 800px"
      >
      <GmapCluster>
        <GmapMarker
          :key="m._id"
          v-for="(m) in usersByCountry"
          :position="{lat: m.location.coordinates[1], lng: m.location.coordinates[0]}"
          :clickable="true"
          :draggable="false"
          :title="m.userName + (m.city ? ' · ' + m.city : '') + (m.country ? ', ' + m.country : '')"
          @click="openMapUser(m)"
        />
        </GmapCluster>
        <GmapInfoWindow
          :options="{pixelOffset: {width: 0, height: -36}}"
          :position="mapInfo.position"
          :opened="mapInfo.open"
          @closeclick="mapInfo.open = false">
          <div style="color:#111;min-width:160px">
            <b>{{ mapInfo.userName }}</b><br>
            <span v-if="mapInfo.city">{{ mapInfo.city }}</span><span v-if="mapInfo.country">, {{ mapInfo.country }}</span>
          </div>
        </GmapInfoWindow>
      </GmapMap>
        <!-- <div class="card">
          <div class="table-responsive">
              <table class="table card-table table-vcenter text-nowrap">
                  <thead>
                      <th>Land</th>
                      <th>Anzahl der Nutzer</th>
                  </thead>
                  <tbody>
                    <tr v-for="country in usersByCountry" :key="country._id">
                    <td class="align-middle">{{ country._id }}</td>
                    <td class="align-middle">{{ country.count }}</td>
                    </tr>
                  </tbody>
              </table>
          </div>
        </div> -->
      </div>
    </v-tab-item>
  </v-tabs-items>

    

      <!-- Dialog Nutzer bearbeiten -->
      <v-dialog
        v-model="editDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="card">
            <h4 class="page-title text-primary">Benutzer bearbeiten</h4>
          </v-card-title>
          <v-card-text>

          <div class="form-group"> 
            <label class="form-label">Benutzername</label> 
            <input type="text" class="form-control" placeholder="" v-model="editUser.userName" v-bind:class="{'is-invalid': emptyValidation && (editUser.userName == null || editUser.userName == '')}"> 
          </div>

          <div class="form-group"> 
            <label class="form-label">E-Mail</label>
            <input type="email" class="form-control" placeholder="" v-model="editUser.email" v-bind:class="{'is-invalid': emptyValidation && (editUser.email == null || editUser.email == '')}">
          </div>

          <div class="form-group"> 
            <label class="form-label">Geburtstag</label> 
            <input type="date" class="form-control" placeholder="" v-model="editUser.dateOfBirthObject" v-bind:class="{'is-invalid': emptyValidation && (editUser.dateOfBirthObject == null || editUser.dateOfBirthObject == '')}"> 
          </div>

          <div class="form-group"> 
            <label class="form-label">Telefonnummer</label> 
            <input type="text" class="form-control" placeholder="" v-model="editUser.telephoneNumber"> 
          </div>
          
          <div class="form-group"> 
            <label class="form-label">Über mich</label> 
            <textarea rows="5" class="form-control" placeholder="" v-model="editUser.about" v-bind:class="{'is-invalid': emptyValidation && (editUser.about == null || editUser.about == '')}"></textarea> 
          </div> 
          
          <div class="form-group"> 
            <label class="form-label">Sprache</label>
            <select name="" id="" class="form-control" v-model="editUser.language" v-bind:class="{'is-invalid': emptyValidation && (editUser.language == null || editUser.language == '')}">
              <option value="de">Deutsch</option>
              <option value="en">Englisch</option>
            </select>
          </div>
          
          <div class="form-group"> 
            <label class="form-label">Verfügbare Coins</label>
            <input type="number" class="form-control" placeholder="" v-model="editUser.currentCoins">
          </div>

          <div class="form-group">
            <label class="form-label">Gefahrene Kilometer</label>
            <!-- min/max nur als Hinweis in der Oberfläche — die eigentliche
                 Prüfung läuft serverseitig (validateUpdateUser), da ein
                 Client-Grenzwert allein sich umgehen lässt. -->
            <input type="number" min="0" max="10000000" class="form-control" placeholder="" v-model="editUser.drivenKilometers">
          </div>

          <div class="form-group">
            <label class="form-label">Verifikationsstatus</label>
            <!--
              WAR FALSCH: v-model stand direkt auf editUser.isVerified, einem
              echten Ja/Nein-Wert vom Server. Ein <select> liefert aber immer
              Zeichenketten — ein Klick in der Liste schrieb das WORT "false"
              hinein statt des Wertes nein. Ein nichtleeres Wort gilt in
              JavaScript als "ja": Der Knopf darunter (v-if="!editUser.isVerified")
              verschwand deshalb genau dann, wenn der Verwalter "Nicht
              verifiziert" auswählte — das Gegenteil der Absicht. Jetzt läuft die
              Auswahl über isVerifiedSelect (siehe computed), das zwischen
              String und echtem Ja/Nein-Wert übersetzt; editUser.isVerified
              bleibt dabei immer ein echter Wert.
            -->
            <select name="" id="" class="form-control" v-model="isVerifiedSelect">
              <option value="true">Verifiziert</option>
              <option value="false">Nicht verifiziert</option>
            </select>
            <a v-if="!editUser.isVerified" class="btn btn-primary btn-pill mt-2" @click="sendNewVerifyMail(editUser)">Neue E-Mail zum Verifizieren schicken</a>
          </div>

          <div class="form-group">
            <label class="form-label">Status</label>
            <!--
              WAR FALSCH (Runde 1): Die Option "Gesperrt" trug den Wert 0, ein
              Zustand, den kein Teil des Systems vorsieht — das Konto wurde
              danach nirgends mehr angezeigt und war nur per Datenbankzugriff
              zu retten. Runde 1 hat den Wert auf 2 korrigiert (den echten
              Sperrstatus). Das griff aber zu kurz: Dieser Dialog speichert
              über PUT /user/update, das NUR den Status setzt. "Sperren" im
              Aktionsmenü (banUser) geht dagegen über POST /user/blacklist,
              das ZUSÄTZLICH einen Sperreintrag in einer eigenen Sammlung
              anlegt — und nur über diesen Eintrag taucht ein Konto auf der
              Seite "Gesperrte Nutzer" auf und lässt sich dort entsperren.
              Über dieses Feld gespeichert landete das Konto also weiterhin in
              einer Sackgasse: raus aus der Benutzerliste (die nur Status 1
              zeigt), aber nicht auf der Sperrliste, also auch dort nicht
              entsperrbar. Die Auswahl "Gesperrt" ist deshalb hier entfernt.
              Sperren/Entsperren läuft ab jetzt ausschließlich über das
              Aktionsmenü in der Liste, das den vollständigen Weg geht.
            -->
            <input type="text" class="form-control" :value="editUser.status === 1 ? 'Aktiv' : 'Gesperrt'" disabled>
            <small class="text-muted d-block mt-1">Sperren/Entsperren nur über das Aktionsmenü in der Liste — das legt zusätzlich den nötigen Sperreintrag an, den diese Maske allein nicht anlegen kann.</small>
          </div>
          <div class="form-group">
            <label class="form-label">Betriebssystem</label>
            <input type="text" class="form-control" placeholder="" v-model="editUser.system" disabled>
          </div>
          <div class="form-group">
            <label class="form-label">App-Version</label>
            <input type="text" class="form-control" placeholder="" v-model="editUser.version" disabled>
          </div>
          <div class="form-group">
            <label class="form-label">Modell</label>
            <input type="text" class="form-control" placeholder="" v-model="editUser.model" disabled> 
          </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="editDialog=false">Abbrechen</a>
              <a class="btn btn-primary btn-pill" @click="saveUser(editUser)">Speichern</a>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- Nutzerfahrzug löschen -->
      <v-dialog v-model="DeleteCarconfirmDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Bestätigen</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Möchten Sie dieses Fahrzeug wirklich löschen?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="deleteCar()">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>


      <!-- Fahrzeuge bearbeiten Dialog -->
      <v-dialog
        v-model="editCarDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="card ">
            Fahrzeug bearbeiten
          </v-card-title>

          <v-card-text>
            <div class="form-group">
                    <label class="form-label">Bilder</label>
                    <v-carousel>
                      <v-carousel-item
                        v-for="(item,i) in editCar.galleryImages"
                        :key="i"
                        :src="`${$img(item.url,$awsLargeImages)}`"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                      ></v-carousel-item>
                    </v-carousel>
                  </div>
            <div class="form-group">
                <label class="form-label">Modell</label>
                <input type="text" class="form-control" placeholder="Modell..." v-model="editCar.model" v-bind:class="{'is-invalid': carEmptyValidation && (editCar.model == null || editCar.model == '')}">
            </div>
            <div class="form-group">
                <label class="form-label">Marke</label>
                <!--
                  Geprueft wurde editCar.make. Dieses Feld gibt es nicht: Weder
                  editCar noch das Modell Auto im Backend kennen "make", dort
                  heißt es brand. undefined == null ist wahr, "Marke" war damit
                  immer rot — und weil das Feld auch nach dem Schliessen des
                  Dialogs im Dokument stehen bleibt, blockierte es über die
                  Prüfung in saveUserToServer zusätzlich jedes Speichern im
                  Benutzer-Dialog.
                -->
                <input type="text" class="form-control" placeholder="Marke..." v-model="editCar.brand" v-bind:class="{'is-invalid': carEmptyValidation && (editCar.brand == null || editCar.brand == '')}">
                <div class="card mb-0" id="autoComplete">
                    <!-- <ul class="list-group p-0">
                      <li class="list-group-item autoCompleteList" v-for="el in autoCompleteResult" :key="el" @click="chooseAutoComplete(el)">{{el}}</li>
                    </ul> -->
                </div>
            </div>
            <div class="form-group"> 
              <label class="form-label">Beschreibung</label> 
              <!--
                Hier stand editUser.about — das falsche Objekt, offenbar aus dem
                Benutzer-Dialog kopiert. Die Beschreibung des Fahrzeugs wurde
                rot markiert, wenn der Text "Ueber mich" des Benutzers leer war,
                und blieb unmarkiert, wenn sie selbst leer war.
              -->
              <textarea rows="5" class="form-control" placeholder="" v-model="editCar.description" v-bind:class="{'is-invalid': carEmptyValidation && (editCar.description == null || editCar.description == '')}"></textarea>
            </div>          
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="editCarDialog=false">Abbrechen</a>
              <a class="btn btn-primary btn-pill" @click="saveCar()">Speichern</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Fahrzeuge anzeigen -->
      <v-dialog
        v-model="showCarsDialog"
        width="75%"
      >
        <v-card>
          <v-card-title class="card">
            <h4 class="page-title text-primary">Fahrzeuge von {{editUser.userName}}</h4>
          </v-card-title>
          <v-card-text>
            <div class="card">
              <div class="table-responsive">
                <table class="table card-table table-vcenter text-nowrap">
                  <thead>
                    <tr>
                      <th>Bild</th>
                      <th>Marke</th>
                      <th>Model</th>
                      <!-- <th>Description</th> -->
                      <th>Aktion</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="car in editUser.cars" :key="car._id">
                      <td class="align-middle">
                        <!--
                          Hier stand car.galleryImages[0].url ohne Prüfung.
                          Ein Fahrzeug ohne Bild lieferte ein leeres
                          galleryImages-Array, [0] war also undefined — der
                          Zugriff auf .url warf und riss den Aufbau der
                          gesamten Fahrzeugliste ab, nicht nur der einen
                          Zeile. Gleiches Muster wie in Posts.vue,
                          UserAutos.vue und Reported.vue: firstImage() liefert
                          bei fehlendem Bild einen leeren Wert statt zu werfen.
                        -->
                        <img v-if="firstImage(car)" :src="`${$img(firstImage(car),$awsSmallImages)}`" alt="img" class="avatar avatar-md brround"/>
                        <i class="fe fe-image text-muted" v-else title="Kein Bild"></i>
                      </td>
                      <td class="align-middle">{{car.brand}}</td>
                      <td class="align-middle">{{car.model}}</td>
                      <!-- <td class="align-middle">{{car.description}}</td> -->
                      <td class="align-middle">
                        <a title="Fahrzeug bearbeiten" class="btn btn-primary btn-small mr-1" @click="openEditCar(car)"><i class="fas fa-edit"></i></a>
                        <a title="Fahrzeug löschen" class="btn btn-small btn-danger mr-1" @click="openDeleteCar(car)" ><i class="fas fa-trash-alt"></i></a>
                      </td>
    
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="showCarsDialog=false">Schließen</a>
          </v-card-actions>
        </v-card>
      </v-dialog>
      

      <!-- Dialog Nutzer löschen -->
      <v-dialog
        v-model="deleteDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="card ">
            Benutzer Löschen
          </v-card-title>

          <v-card-text>
            <label class="form-label">Bitte geben sie den Grund für das Löschen des Benutzers an</label>
            <textarea rows="5" class="form-control" placeholder="" v-model="deleteReason"></textarea>           
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="deleteUser(editUser)">Löschen</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="emptyDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Fehler</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Zum Speichern müssen alle Felder ausgefüllt sein.
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="emptyDialog=false">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="banDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Benutzer sperren</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Sind Sie sicher, dass Sie diesen Benutzer auf die Sperrliste setzen möchten? <br><br>
          Das Konto verschwindet damit aus dieser Liste — sie zeigt nur aktive
          Konten. Es wird nicht gelöscht: Es steht danach unter "Gesperrte
          Nutzer" und kann dort jederzeit wieder freigeschaltet werden.
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <!--
                WAR FALSCH: Dieser Dialog hatte als einzigen Knopf "Sperren".
                Wer ihn versehentlich geöffnet hatte, fand keinen sichtbaren
                Ausweg — der einzige angebotene Weg war die Sperrung selbst.
                (Schließen ging nur über Esc oder einen Klick daneben, was
                niemand raten muss.) Der Lösch-Dialog weiter oben hat sein
                "Abbrechen" seit jeher; hier fehlte es.
              -->
              <a class="btn btn-primary btn-pill mr-1" @click="banDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="banUser()">Sperren</a>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unbanDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Benutzer entsperren</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Sind Sie sicher, dass Sie diesen Benutzer wieder freischalten möchten?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <!-- Siehe Sperren-Dialog: auch hier gab es keinen Ausweg außer Esc. -->
              <a class="btn btn-primary btn-pill mr-1" @click="unbanDialog=false">Abbrechen</a>
              <a class="btn btn-primary btn-pill" @click="unbanUser()">Entsperren</a>
          </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  
</div>
</template>

<script>
import GmapCluster from "vue2-google-maps/dist/components/cluster";

export default {

  components: {
    GmapCluster
  },

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      lastUsers: null,
      sort: null,
      // WAR FALSCH: order stand auf true, orderReq auf 1 (aufsteigend). Ohne
      // angeklickte Spalte schickt fetchUser() trotzdem sort/orderReq mit
      // ("null" und "1"). Das Backend erkennt "null" nicht als gültiges
      // Sortierfeld und fällt auf das Anmeldedatum zurück, übernimmt aber die
      // mitgeschickte Richtung — die stand auf aufsteigend. Ergebnis: Die
      // Seite öffnete sich mit den ÄLTESTEN Konten oben, die von heute erst
      // nach vollständigem Durchscrollen. -1 (absteigend) macht aus dem
      // Rückfall tatsächlich das, was der Kommentar unten seit jeher behauptet.
      order: false,
      orderReq: -1,
      routes: {
      },
      search: "",
      users: [],
      // Trennt "lädt gerade" von "wirklich leer" von "Abruf gescheitert" —
      // siehe Kommentar in fetchUser()/searchUser() und die Leerzeile im
      // Template.
      loading: false,
      fetchError: '',
      roles: [],

      menu: false,
      createmode: true,

      // Personal Data
      me: null,

      editUser: {
        userName: "",
        email: "",
        dateOfBirth: "",
        image: "",
        about: "",
        telephoneNumber: "",
        language: "",
        currentCoins: "",
        drivenKilometers: "",
        status: "",
        dateOfBirthObject: "",
        cars: null,
      },

      // editCar stand hier zweimal: weiter oben noch einmal als leeres Objekt.
      // In einem Objektliteral gewinnt der letzte Eintrag, der erste war also
      // wirkungslos — er täuschte aber vor, das Fahrzeugobjekt starte ohne
      // Felder. "description" fehlte: Die Maske bindet Modell, Marke und
      // Beschreibung, die Aufzählung nannte nur zwei davon.
      editCar: {
        brand: null,
        model: null,
        description: null,
      },

      editDialog: false,
      showCarsDialog: false,
      editCarDialog:false,
      deleteDialog: false,
      emptyDialog: false,
      banDialog: false,
      unbanDialog: false,
      DeleteCarconfirmDialog: false,

      // Zwei Masken, zwei Flags. Vorher teilten sich Benutzer- und
      // Fahrzeug-Dialog ein einziges emptyValidation. saveUser() setzt es auf
      // true, bevor Telefonnummer und E-Mail geprueft werden — bricht eine
      // dieser Pruefungen ab, bleibt das Flag stehen und markierte anschließend
      // auch im Fahrzeug-Dialog Felder rot, die dort gar nicht beanstandet
      // wurden. Getrennte Flags sind hier die sauberere Lösung, weil jeder
      // Dialog seinen eigenen Speichern-Knopf hat: Der Zustand "es wurde
      // gespeichert und etwas fehlte" gehört zum jeweiligen Dialog, nicht zur
      // Seite.
      emptyValidation: false,
      carEmptyValidation: false,
      deleteReason: '',
      currentTimeSpan: 'AllTime', 
      userTab: null,
      center: {lat: 51.1642292, lng: 10.4541194}, 
      usersByCountry: [],
      // Sprechblase auf der Karte: zeigt, wer an diesem Punkt sitzt
      mapInfo: { open: false, position: null, userName: '', city: '', country: '' },
      // Referenz auf den in mounted() angemeldeten $root-Zuhörer, damit
      // beforeDestroy ihn wieder abmelden kann (siehe dort).
      usersListener: null,
      // Verzögert die Suche um 300 ms, wie schon in Crews.vue. Ohne das ging
      // pro Tastendruck eine eigene Serveranfrage raus.
      searchTimer: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    // WAR FALSCH: Jeder Tastendruck löste sofort eine eigene Serveranfrage
    // aus — bei "nightride" also neun Anfragen statt einer. Auf einer
    // langsamen Verbindung flackerte die Liste, und weil Antworten nicht
    // zwingend in Reihenfolge zurückkommen, konnte kurzzeitig das Ergebnis
    // eines älteren, unvollständigen Suchbegriffs stehen bleiben. Jetzt wird
    // wie in Crews.vue 300 ms gewartet und ein noch nicht abgeschickter
    // Zeitgeber verworfen, bevor ein neuer gesetzt wird.
    search : function(){
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if(this.search == ""){
          this.fetchUser();
        }else{
          this.page = 0;
          this.searchUser();
        }
      }, 300);
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    },
    // Vuetify lässt den Inhalt eines einmal geöffneten Dialogs im Dokument
    // stehen. Bleiben dort Felder mit is-invalid zurück, blockiert die
    // dokumentweite Pruefung in saveUserToServer das Speichern im
    // Benutzer-Dialog. Deshalb wird das Flag beim Schließen zurückgesetzt.
    editCarDialog: function () {
       if(this.editCarDialog == false) {
         this.carEmptyValidation = false;
         this.$forceUpdate();
       }
    },
    // 'order': function(){
    //   console.log("orderchanged")
    //   if(!this.order){
    //     this.orderReq = '1';
    //     console.log("false")
    //   }else if(this.order){
    //     this.orderReq = '-1';
    //     console.log("true")
    //   }
    // }
  },

  computed: {
    // Übersetzt zwischen dem echten Ja/Nein-Wert editUser.isVerified und der
    // Zeichenkette, die das <select> darunter braucht. Siehe Kommentar am
    // Feld im Template.
    isVerifiedSelect: {
      get() {
        return this.editUser.isVerified ? 'true' : 'false';
      },
      set(val) {
        this.editUser.isVerified = (val === 'true');
      },
    },
  },

  mounted() {
    // Hier wurde custom.js ein zweites Mal nachgeladen, und zwar unter
    // '../../public/js/custom.js'. Den Pfad gibt es im ausgelieferten Stand
    // nicht — public/ ist die Wurzel, nicht ein Unterordner. Der Browser bekam
    // die index.html zurück und meldete "Refused to execute script ...
    // MIME type ('text/html') is not executable". Die Datei wird bereits in
    // public/index.html am Ende des Rumpfes eingebunden (<script src=
    // "/js/custom.js">), die zweite Einbindung war also auch inhaltlich
    // überflüssig.
    this.fetchUser();
    this.fetchUserPerCountry();
    if(this.$route.params.user) {
      this.openEditUser(this.$route.params.user, 'edit');
    }
    // Referenz gemerkt, damit beforeDestroy denselben Zuhörer wieder abmelden
    // kann — $root.$off ohne Funktionsreferenz würde ALLE Zuhörer auf
    // 'Users' entfernen, auch die noch aktiver Instanzen.
    this.usersListener = (user) => {
      this.openEditUser(user, 'edit');
    };
    this.$root.$on('Users', this.usersListener);
  },

  beforeDestroy() {
    // WAR FALSCH: Dieser Zuhörer wurde nie wieder abgemeldet. $root gehört
    // zur ganzen Anwendung und überlebt den Seitenwechsel — jeder erneute
    // Besuch dieser Seite meldete einen weiteren Zuhörer an. Ein Treffer der
    // Kopfzeilen-Suche öffnete den Bearbeiten-Dialog danach so oft, wie die
    // Seite in dieser Sitzung schon besucht wurde, mit ebenso vielen
    // Server-Anfragen (/user/admin/profile/<id>/0/1).
    if (this.usersListener) {
      this.$root.$off('Users', this.usersListener);
    }
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },

  methods: {
    // Liefert die erste Bildadresse eines Fahrzeugs oder einen leeren Wert.
    // Gleiche Absicherung wie firstImage() in Posts.vue und UserAutos.vue.
    firstImage(car) {
      if (!car || !car.galleryImages || car.galleryImages.length === 0) return "";
      return car.galleryImages[0].url;
    },
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                if(this.lastUsers == this.ElementPerPage || this.lastUsers == null){
                  // Die Sortierparameter gehören IMMER mit — auch wenn kein
                  // Spaltenkopf angeklickt wurde. Ohne sie greift im Backend
                  // eine andere Abfrage mit umgekehrter Richtung: Der
                  // Erstabruf holte die 25 ältesten Konten, das Nachladen die
                  // Plätze 26 bis 50 der neuesten. Die neuesten 25 erschienen
                  // nie, die ältesten 25 doppelt. Ist sort leer, fällt das
                  // Backend auf Anmeldedatum absteigend zurück.
                  const sortTeil = '/' + this.sort + '/' + this.orderReq;
                  const zeit = this.getCurrentTimeSpan();

                  // Die NÄCHSTE Seite anfragen, nicht die aktuelle. Hier stand
                  // `const von = this.page * this.ElementPerPage` VOR dem
                  // `page++` — beim ersten Scrollen ergab das skip 0, also
                  // genau die 25 Einträge, die schon in der Liste stehen. Sie
                  // wurden ein zweites Mal angehängt.
                  //
                  // Und die Seitenzahl steigt erst NACH einer erfolgreichen
                  // Antwort: Scheitert die Anfrage, bliebe sie sonst erhöht
                  // und die Seite wäre dauerhaft übersprungen.
                  // (Gleiches Muster wie in Manufacturers.vue.)
                  const naechsteSeite = this.page + 1;
                  const von = naechsteSeite * this.ElementPerPage;

                  // WAR FALSCH: response.data.data wurde hier ungeprüft
                  // benutzt, obwohl fetchUser()/searchUser() dieselbe Antwort
                  // längst absichern. Bei einem fachlichen Fehlschlag (HTTP 200
                  // mit success:false) liefert dieses Backend gar kein
                  // data-Feld — der Zugriff auf .length warf dann, der Fehler
                  // landete still im .catch und das Nachladen blieb ohne jede
                  // Rückmeldung stehen. Gleiche Absicherung wie in Reported.vue.
                  const anhaengen = (response) => {
                    // Ein fachlicher Fehlschlag (HTTP 200 mit success:false)
                    // sah bisher exakt aus wie "die Liste ist zu Ende": kein
                    // data-Feld, also nichts angehängt, und still weiter. Der
                    // Verwalter scrollte und dachte, mehr gebe es nicht.
                    // Ein Netzfehler an derselben Stelle meldet sich dagegen
                    // längst (.catch -> onError) — die Stille galt also nur
                    // für Ablehnungen des Servers. Jetzt beides gleich.
                    if (response.data != null && response.data.success === false) {
                      _this.lastUsers = 0;
                      _this.onError(response.data);
                      return;
                    }
                    const neue = (response.data && response.data.data) || [];
                    _this.lastUsers = neue.length;
                    if(neue.length >= 1) {
                      _this.page = naechsteSeite;
                      neue.forEach(item => _this.users.push(item));
                    }
                  };

                  if(this.search ==  "" || this.search == null){
                    this.$axios
                          .get('/user/all/' + von + '/' + this.ElementPerPage + '/' + zeit + sortTeil)
                          .then(anhaengen)
                          .catch(this.onError);
                  }
                  else{
                    // Suchbegriff kodieren: Er steht im Pfad, ein „/" darin
                    // ergäbe ein zusätzliches Segment und damit einen 404.
                    this.$axios
                          .get('/user/admin/search/' + encodeURIComponent(this.search) + '/' + von + '/' + this.ElementPerPage + '/' + zeit + sortTeil)
                          .then(anhaengen)
                          .catch(this.onError);
                  }
                }
            }, 500);
        }
    },
    fetchUser() {
      var _this = this;
      // Diese Abfrage ERSETZT die Liste (users = ..., nicht push). Also gehört
      // die Seitenzahl zurück auf Anfang. Ohne das blieb sie stehen: Nach
      // zweimal Scrollen und einem Klick auf einen Spaltenkopf sprang das
      // nächste Nachladen auf Eintrag 75 — die Plätze 1 bis 50 waren nicht
      // mehr erreichbar.
      this.page = 0;
      // WAR FALSCH: Es gab keine "lädt gerade"-Anzeige und keine Trennung
      // zwischen "wirklich leer" und "Abruf ist fehlgeschlagen". Die neue
      // Leerzeile unten im Template ("Keine Benutzer gefunden.") stand dadurch
      // auch WÄHREND des Ladens und bei einem Fehlschlag da — beides falsch.
      // loading/fetchError trennen jetzt die drei Zustände (wie in Crews.vue).
      this.loading = true;
      this.fetchError = '';
      this.$axios.get('/user/all/0/'+ this.ElementPerPage  + '/' + this.getCurrentTimeSpan() + '/' + this.sort + '/' + this.orderReq).then(function(response){
        _this.loading = false;
        // WAR FALSCH: response.data.success wurde nicht geprüft und
        // response.data.data ungeprüft in users geschrieben. Bei einem
        // fachlichen Fehlschlag (HTTP 200, success:false) hat dieses Backend
        // KEIN data-Feld — users.length griff dann auf undefined zu und
        // die Seite stürzte beim Zeichnen ab.
        if (response.data == null || response.data.success === false) {
          _this.users = [];
          // Auf 0 statt unberührt: lastUsers steuert, ob beim Scrollen
          // nachgeladen wird. Blieb der alte Wert stehen, hängte das Nachladen
          // weiter Seiten an eine Liste, die wegen fetchError gar nicht
          // angezeigt wird.
          _this.lastUsers = 0;
          _this.fetchError = (response.data && response.data.message) || 'Der Server hat die Anfrage abgelehnt.';
          return;
        }
        _this.users = response.data.data || [];
        _this.lastUsers = _this.users.length;
      }).catch(function(error){
        _this.loading = false;
        // WAR FALSCH (Runde 2): Hier wurde nur fetchError gesetzt, die alte
        // Liste blieb unangetastet stehen — auf dem Bildschirm standen danach
        // Fehlermeldung und veraltete Trefferliste gleichzeitig. Diese Abfrage
        // ERSETZT die Liste; scheitert sie, gibt es keine gültige Liste mehr,
        // also wird sie geleert (wie im success:false-Zweig darüber).
        _this.users = [];
        _this.lastUsers = 0;
        _this.fetchError = _this.serverMessage(error);
        _this.onError(error);
      });
    },
    fetchUserCars(user){
      var _this = this;
      this.editUser = user;
      // WAR FALSCH: Dieser Aufruf hatte gar keinen .catch. Schlug die Anfrage
      // fehl (Zeitüberschreitung, 500, abgelaufene Anmeldung), endete die
      // Kette still — kein Dialog, keine Meldung, nichts. Ein Klick auf
      // "Fahrzeuge" wirkte dann wie ein kaputter Menüpunkt.
      this.$axios.get('auto/user/' + user._id).then(function(response){
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        // `|| []` statt der nackten Zuweisung: Ohne data-Feld stand hier
        // undefined, und die Schleife im Fahrzeug-Dialog lief auf einem Wert,
        // den es nicht gibt.
        _this.editUser.cars = (response.data && response.data.data) || [];
        _this.showCarsDialog = true;
        _this.$forceUpdate();
      }).catch(this.onError);
    },
    searchUser(){
      var _this = this;
      // Durchgehend /user/admin/search — dieselbe Route, die auch das
      // Nachladen beim Scrollen benutzt (weiter oben in dieser Datei).
      // Zuvor holte der Erstabruf über /user/search und das Nachladen über
      // /user/admin/search: zwei Endpunkte mit unterschiedlichen Feldern und
      // unterschiedlicher Sortierung, wodurch Zeilen doppelt erschienen oder
      // ganz fehlten. /user/search bleibt der App vorbehalten und liefert
      // bewusst keine Aktivitätswerte.
      //
      // Wie fetchUser: Diese Abfrage ersetzt die Liste, also zurück auf
      // Seite 0. Und der Suchbegriff steht im Pfad — ein „/" darin ergäbe
      // sonst ein zusätzliches Segment und damit einen 404, ein „%" bräche
      // die Adresse ganz.
      this.page = 0;
      const begriff = encodeURIComponent(this.search);
      // WAR FALSCH: Ohne gesetzte Spaltensortierung rief dieser Zweig die
      // Adresse OHNE sort/orderReq auf — das trifft im Backend eine andere
      // Variante der Suche (Relevanz, dann neuestes Datum) als das Nachladen
      // beim Scrollen weiter unten in dieser Datei, das sort/orderReq IMMER
      // mitschickt (auch als Text "null"/"-1"). Zwei verschiedene
      // Sortierungen für dieselbe Liste heißt: Position 26 beim Nachladen
      // zeigt auf einen anderen Nutzer, als die erste Seite zuletzt zeigte —
      // Konten erschienen doppelt oder gar nicht. Jetzt schickt der Erstabruf
      // dieselben Parameter wie das Nachladen, genau wie schon bei fetchUser().
      this.loading = true;
      this.fetchError = '';
      this.$axios.get('/user/admin/search/' + begriff +'/0/' + this.ElementPerPage  + '/' + this.getCurrentTimeSpan() + '/' + this.sort + '/' + this.orderReq).then(function(response){
        _this.loading = false;
        if (response.data == null || response.data.success === false) {
          _this.users = [];
          _this.lastUsers = 0;
          _this.fetchError = (response.data && response.data.message) || 'Der Server hat die Anfrage abgelehnt.';
          return;
        }
        _this.users = response.data.data || [];
        _this.lastUsers = _this.users.length;
      }).catch(function(error){
        _this.loading = false;
        // Siehe fetchUser(): Die alte Liste blieb im Fehlerfall stehen und
        // stand dann zusammen mit der Fehlerzeile auf dem Bildschirm.
        _this.users = [];
        _this.lastUsers = 0;
        _this.fetchError = _this.serverMessage(error);
        _this.onError(error);
      });
    },
    // Lädt die Liste so neu, wie sie gerade angezeigt wird.
    //
    // WAR FALSCH: Löschen, Sperren und Entsperren riefen fest fetchUser() auf —
    // und das holt IMMER die ungefilterte Gesamtliste. Wer nach einem Namen
    // gesucht, den einen Treffer gesperrt und dann hingesehen hat, fand im
    // Suchfeld weiter seinen Begriff, in der Tabelle darunter aber alle 25
    // Nutzer. Es sah aus, als hätte sich die Suche von selbst zurückgesetzt.
    // Jetzt entscheidet dieselbe Regel wie beim Beobachter am Suchfeld: mit
    // Begriff wird gesucht, ohne wird die volle Liste geholt. Beide Methoden
    // setzen page selbst auf 0 zurück. Gleiches Muster wie reloadModels() in
    // UserAutos.vue.
    reloadUsers() {
      if (this.search == null || this.search === "") {
        this.fetchUser();
      } else {
        this.searchUser();
      }
    },
    onError(err) {
      // Hier stand this.console.log — `console` ist kein Feld der Komponente.
      // Der Fehlerbehandler warf dadurch selbst einen Fehler, und die
      // eigentliche Ursache ging verloren.
      if (err != null && err.response != null && err.response.data != null) {
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      // WAR FALSCH: Dieser Behandler schrieb ausschließlich in die
      // Entwicklerkonsole des Browsers, die niemand offen hat. Schlug der
      // Abruf fehl, blieb die Tabelle einfach leer — genau wie bei "es gibt
      // wirklich nichts". Niemand konnte die beiden Fälle unterscheiden. Bei
      // 401/403 bleibt es bei der zentralen Meldung aus main.js (Abmeldung
      // bzw. Berechtigungshinweis) — eine zweite Meldung hier würde diese
      // sofort wieder verdecken (Noty läuft mit killer: true).
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      // WAR FALSCH: Die schreibenden Aktionen (Löschen, Sperren, Entsperren)
      // reichen hier den ANTWORTKÖRPER herein — also {success:false,
      // message:"Der von Ihnen eingegebene Benutzername wird bereits
      // verwendet"} —, nicht ein Axios-Fehlerobjekt. Der Text darin ging
      // bisher verloren und der Verwalter las nur "Etwas ist schief gelaufen".
      // Genau die Angabe, die ihm sagt, WAS er ändern muss, fiel damit weg.
      const message = this.failureMessage(err);
      if (message) {
        this.$noty.error(message);
        return;
      }
      this.$showCommonError();
    },
    // Liefert AUSSCHLIESSLICH den Klartext, den der Server geschickt hat —
    // sonst null. Zwei Formen kommen vor:
    //   1. Axios-Fehler (HTTP 4xx/5xx): der Text steckt in err.response.data
    //   2. Antwortkörper eines fachlichen Fehlschlags: {success:false,
    //      message:"…"} kommt mit HTTP 200 und wird von den schreibenden
    //      Aktionen direkt hier hereingereicht
    // Bewusst NICHT err.message eines Axios-Fehlers: Das ist der technische
    // englische Text ("Request failed with status code 500", "Network Error")
    // und hat in einer deutschen Oberfläche nichts verloren.
    failureMessage(err) {
      if (err == null) return null;
      if (err.response != null && err.response.data != null && err.response.data.message) {
        return err.response.data.message;
      }
      if (err.response == null && err.success === false && err.message) {
        return err.message;
      }
      return null;
    },
    // Liefert einen anzeigbaren Text zu einem fehlgeschlagenen Abruf, für die
    // Fehlerzeile in der Tabelle (siehe fetchUser/searchUser). Gleiches
    // Muster wie in Crews.vue.
    serverMessage(error, fallback) {
      return this.failureMessage(error) || fallback || 'Die Anfrage ist fehlgeschlagen.';
    },
    openEditCar(car){
      var _this = this;

      this.editCar = Object.assign({},car);
      // Frisch geöffneter Dialog zeigt keine Beanstandungen aus einem
      // früheren Speicherversuch.
      this.carEmptyValidation = false;
      this.editCarDialog = true;
    },
    openDeleteCar(car){
      var _this = this;
      this.editCar = car;
      this.DeleteCarconfirmDialog = true;
      
    },
    deleteCar(){
      var _this = this;
      this.$axios.delete("/auto/delete/" + _this.editCar._id).then(function (response) {
          // WAR FALSCH: ungeprüfter Erfolgszweig. respondFailure antwortet mit
          // HTTP 200 und success:false (etwa wenn das Fahrzeug schon weg ist) —
          // der Bestätigungsdialog ging trotzdem zu, als sei gelöscht worden.
          if (response.data != null && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.DeleteCarconfirmDialog = false;
          _this.fetchUserCars(_this.editUser);
          _this.$forceUpdate();

        }).catch(function(error){
          // WAR FALSCH: Nur console.error — der Knopf "Löschen" wirkte bei
          // einem Serverfehler völlig wirkungslos.
          _this.onError(error);
        });
    },
    saveCar(){
      var _this = this;

      // Erst ab dem Speicherversuch werden leere Felder markiert — vorher hing
      // die Markierung am Flag des Benutzer-Dialogs und schlug dort zu, wo gar
      // nichts gespeichert wurde. Absichtlich ohne Abbruch: Das Backend
      // (ETSBackend/models/Auto.js) verlangt keines dieser Felder, ein
      // erzwungener Abbruch würde das bisherige Verhalten ändern.
      this.carEmptyValidation = true;

      // WAR FALSCH: Hier wurde der komplette Datensatz des Servers kopiert und
      // eine feste Liste bekannter Felder wieder herausgelöscht.
      //
      // Was ein Mensch merkt: Der Verwalter öffnet bei einem Nutzer
      // "Fahrzeuge", ändert Marke oder Beschreibung, drückt Speichern — und
      // bekommt eine Fehlermeldung. Gespeichert wird nichts, und zwar bei
      // jedem Fahrzeug.
      //
      // Warum: Seit der Umstellung auf den Marken-Katalog liefert der Server
      // vier zusätzliche Felder mit (carManufacturer, modelName,
      // legacyBrandText, legacyModelText). Die Löschliste kannte sie nicht,
      // also gingen sie beim Speichern wieder mit. Die Prüfung im Backend
      // (helpers/inputValidation.js, validateUpdateAuto) zählt aber
      // abschließend auf, was erlaubt ist, und weist alles Unbekannte mit
      // HTTP 422 ab. Eine Löschliste ist deshalb grundsätzlich der falsche
      // Weg: Jedes neue Feld am Fahrzeug bricht sie erneut.
      //
      // Jetzt wird — wie in UserAutos.vue, saveModel() — nur noch das
      // aufgezählt, was gesendet werden soll.
      const carToSave = {
        autoId: this.editCar._id,
        brand: this.editCar.brand,
        model: this.editCar.model,
        year: this.editCar.year,
        // updateAuto baut galleryImages aus existingImages neu auf; fehlt das
        // Feld, wären alle Bilder weg.
        existingImages: JSON.stringify(this.editCar.galleryImages || []),
        deletedImages: JSON.stringify([]),
        // category und videoLink dürfen leer sein, werden aber immer
        // mitgesendet: updateAuto weist sie ungeprüft zu, fehlen sie, entfernt
        // Mongoose die Felder aus dem Datensatz.
        category: this.editCar.category != null ? this.editCar.category : "",
        videoLink: this.editCar.videoLink != null ? this.editCar.videoLink : "",
      };
      // description ist als Joi.string() ohne allow('') beschrieben — ein
      // leerer Text hätte die ganze Anfrage mit 422 abgelehnt (gleicher Grund
      // wie in UserAutos.vue).
      if (this.editCar.description != null && this.editCar.description !== "") {
        carToSave.description = this.editCar.description;
      }

      const body = this.$formatUrlEncoded(carToSave)


      this.$axios.put('/auto/update', body).then(function(response){
        // WAR FALSCH: ungeprüfter Erfolgszweig. Bei HTTP 200 mit success:false
        // schloss sich der Dialog, als sei gespeichert worden.
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        _this.editCarDialog = false;
        _this.carEmptyValidation = false;
        // WAR FALSCH: Die Fahrzeugliste im Dialog dahinter wurde nicht neu
        // geholt. openEditCar arbeitet auf einer Kopie (Object.assign) — die
        // Zeile zeigte deshalb weiter die alten Werte, obwohl gespeichert
        // wurde. Gleiches Vorgehen wie in deleteCar().
        _this.fetchUserCars(_this.editUser);
        _this.$forceUpdate();
      }).catch(function(error){
        // WAR FALSCH: Nur console.error — ein abgewiesenes Speichern (z. B.
        // HTTP 422 aus der Joi-Prüfung) blieb ohne jede Rückmeldung.
        _this.onError(error);
      });
    },
    openEditUser(user){
      var _this = this;

      this.$axios.get(`/user/admin/profile/${user._id}/0/1`).then(function(response){
        // WAR FALSCH: Die Antwort wurde ungeprüft übernommen. Antwortet der
        // Server fachlich ablehnend (HTTP 200 mit success:false, etwa weil das
        // Konto zwischenzeitlich gelöscht wurde), gibt es kein data-Feld:
        // Object.assign({}, undefined) ergibt {} — der Bearbeiten-Dialog ging
        // dann mit vollständig leeren Feldern auf, als hätte der Nutzer keine
        // Daten. Wer darin speicherte, schickte eine leere Maske an den Server.
        if (response.data == null || response.data.success === false || response.data.data == null) {
          _this.onError(response.data);
          return;
        }
        _this.editUser = Object.assign({}, response.data.data);
        if(_this.editUser.dateOfBirth) {
          _this.editUser.dateOfBirthObject = _this.editUser.dateOfBirth.year + '-' + _this.editUser.dateOfBirth.month + '-' + _this.editUser.dateOfBirth.date;
        }
        _this.editDialog = true;
        delete _this.editUser.coinvalue;
        delete _this.editUser.createdAt;
        delete _this.editUser.currentLevel;
        delete _this.editUser.currentLevelImage;
        delete _this.editUser.fcmToken;
        delete _this.editUser.followers;
        delete _this.editUser.following;
        delete _this.editUser.forgotPasswordOtp;
        delete _this.editUser.homezone;
        delete _this.editUser.inHomeZone;
        delete _this.editUser.isHomeZoneAdded;
        delete _this.editUser.isNotificationEnabled;
        delete _this.editUser.location;
        delete _this.editUser.loginType;
        delete _this.editUser.onlineStatus;
        delete _this.editUser.password;
        delete _this.editUser.totalCoinsEarned;
        delete _this.editUser.trackStatus;
        delete _this.editUser.updatedAt;
        delete _this.editUser.coinValue;
        delete _this.editUser.lastLocationOutsideHomeZone;
        delete _this.editUser.lastActive;
      }).catch(function(error){
        // WAR FALSCH: Nur console.error. Ein Klick auf "Bearbeiten" (oder ein
        // Treffer der Kopfzeilen-Suche, der hier landet) blieb bei einem
        // Serverfehler vollkommen wirkungslos — kein Dialog, keine Meldung.
        // Dieselbe Lücke wie beim Menüpunkt "Fahrzeuge" (fetchUserCars).
        _this.onError(error);
      })

    },
    saveUser() {
      let _this = this;
      
      this.emptyValidation = true;
      this.$forceUpdate();

      if(this.editUser.telephoneNumber) {
        this.editUser.telephoneNumber = this.editUser.telephoneNumber.trim().replace(/[()+]/g, '');
        if(!/^[0-9]*$/.test(this.editUser.telephoneNumber)) {
          this.$showErrorInvalid('Telefonnummer');
          return;
      }
      }
      // WAR FALSCH: (\.\w{2,3})+ verlangte am Ende zwingend eine Domainendung
      // aus zwei oder drei Zeichen. Als das Muster entstand, gab es fast nur
      // solche (.de, .com) — seit Jahren sind längere üblich (.info, .online,
      // .travel, .agency …). Das Dashboard lehnte damit gültige Adressen ab,
      // die der Server (Joi.string().email(), inputValidation.js) anstandslos
      // angenommen hätte. {2,24} deckt auch die längsten heute vergebenen
      // Endungen ab.
      if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,24})+$/.test(this.editUser.email)) {
        this.$showErrorInvalid('E-Mail');
        return;
      }
      
      Vue.nextTick(() => {
        _this.saveUserToServer();
      });
    },
    saveUserToServer(){
      let _this = this;
      
      const userSaveSchema = { 
        userName: '',
        _id: '',
        dateOfBirth: {},
        image: '',
        about: '',
        telephoneNumber: '',
        language: '',
        currentCoins: '',
        status: '',
        drivenKilometers: '',
        email: '',
        isVerified: '',
      }
      if(document.getElementsByClassName('is-invalid').length > 0) {
        this.emptyDialog = true;
        return;
      }
      const userToSave = Object.assign({}, this.editUser);
      userToSave.dateOfBirth = this.convertDateToObject(userToSave.dateOfBirthObject);

      delete userToSave.dateOfBirthObject;
      delete userToSave.__v;
      delete userToSave.deviceId;
      delete userToSave.version;
      delete userToSave.model;
      delete userToSave.system;
      delete userToSave.cars;
      if(userToSave.telephoneNumber === null) delete userToSave.telephoneNumber;

      for(const [key] of Object.entries(userToSave)) {
        const validKeys = Object.keys(userSaveSchema);
        if(!validKeys.includes(`${key}`)) {
          delete userToSave[key];
        }
      }
      
      const body = this.$formatUrlEncoded(userToSave);
      this.$axios.put('/user/update', body).then(function(response){
        // WAR FALSCH: Der Erfolgszweig schloss den Dialog ungeprüft. Der Server
        // lehnt aber in drei ganz alltäglichen Fällen ab und antwortet dabei
        // mit HTTP 200 und success:false (adminController.updateUser):
        // Benutzername, E-Mail oder Telefonnummer sind schon vergeben.
        // Gemessen am QA-Server: PUT /user/update mit einem fremden
        // Benutzernamen -> HTTP 200 {"success":false,"message":"Der von Ihnen
        // eingegebene Benutzername wird bereits verwendet"}, Datensatz in der
        // Datenbank unverändert. Der Dialog ging trotzdem zu, ohne ein Wort —
        // der Verwalter hielt die Änderung für gespeichert.
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        _this.editDialog = false;
        _this.emptyValidation = false;
        // WAR FALSCH: Die Liste wurde nach dem Speichern nicht neu geholt.
        // openEditUser arbeitet auf einer KOPIE (Object.assign) — die Zeile in
        // der Tabelle behielt deshalb den alten Namen, die alte E-Mail, die
        // alten Punkte. Erst ein Neuladen der Seite zeigte, was gespeichert
        // wurde. Löschen/Sperren/Entsperren machen das längst so.
        _this.reloadUsers();
        _this.$forceUpdate();
      }).catch(function(error){
        // WAR FALSCH: Nur console.error. Eine mit HTTP 422 abgewiesene Eingabe
        // (Joi-Prüfung im Backend, etwa eine E-Mail-Endung, die der Server
        // nicht kennt) blieb damit vollkommen unsichtbar: Der Knopf
        // "Speichern" tat scheinbar nichts, der Dialog blieb offen, es kam
        // keine Meldung. 401/403 fängt weiterhin main.js zentral ab.
        _this.onError(error);
      });
    },
    openDeleteUser(user) {
      this.deleteDialog = true;
      this.editUser = user;
    },
    deleteUser() {
      let _this = this;
      // Delete User
      const body = {
        userId: this.editUser._id,
        reason: this.deleteReason,
      }
      this.$axios.post('user/delete', body).then(function(response){
        // WAR FALSCH: Weder wurde response.data.success geprüft, noch die
        // Liste neu geladen. respondFailure antwortet mit HTTP 200 und
        // success:false (z. B. "Benutzer wurde nicht gefunden") — das landete
        // bisher unbemerkt im Erfolgszweig, der Dialog ging trotzdem zu, und
        // die Zeile blieb unverändert stehen, egal ob gelöscht wurde oder
        // nicht. Sperren/Entsperren riefen bereits fetchUser() auf, Löschen
        // nicht.
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        _this.deleteDialog = false;
        // reloadUsers() statt fetchUser(): behält einen laufenden Suchbegriff
        // bei, siehe Kommentar an der Methode.
        _this.reloadUsers();
      }).catch(function(error){
        _this.onError(error);
      })
    },
    convertDateToString(dateString){
      var dateobj = this.convertDateToObject(dateString);
      let str = dateobj.date.substring(0,2) + "." + dateobj.month + "." + dateobj.year;
      return str;
    },
    convertDateToObject(dateString) {
      let dateObject = {
        year: '',
        month: '',
        date: '',
      }
      dateObject.year = dateString.substring(0, dateString.indexOf('-'));
      dateObject.month = dateString.substring(dateObject.year.length + 1, dateObject.year.length + 3);
      dateObject.date = dateString.substring(dateObject.month.length + dateObject.year.length + 2);

      return dateObject;
    },
    openBanUser(user) {
      this.editUser = user;
      this.banDialog = true;
    },
    banUser() {
      let _this = this;

      // WAR FALSCH: Weder hier noch bei unbanUser() wurde response.data.success
      // geprüft. respondFailure liefert HTTP 200 mit success:false, etwa wenn
      // das Konto nicht mehr gefunden wird — der Dialog ging trotzdem zu, die
      // Liste wurde neu geladen, und der Nutzer stand unverändert da, ohne
      // jede Fehlermeldung. Es sah aus, als hätte der Klick nichts getan.
      const body = { userId: this.editUser._id };
      // Den Namen VOR dem Neuladen sichern: reloadUsers() ersetzt die Liste,
      // und editUser zeigt auf einen Eintrag daraus.
      const gesperrterName = this.editUser.userName || 'Das Konto';
      this.$axios.post('/user/blacklist/', body).then(function(response){
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        // WAR FALSCH: Bei Erfolg passierte sichtbar nur eines — die Zeile war
        // weg. Kein Wort dazu, wohin. Der Server nimmt gesperrte Konten aus
        // dieser Liste heraus (ACTIVE-Filter), also sieht eine geglückte
        // Sperrung genauso aus wie eine Löschung: Der Eintrag verschwindet
        // spurlos. Wer das nicht wusste, hielt das Konto für gelöscht und
        // suchte es anschließend vergeblich über das Suchfeld — auch die
        // Suche liefert nur aktive Konten. Die Meldung sagt jetzt, was
        // geschehen ist und wo das Konto ab jetzt steht.
        _this.$noty.success(gesperrterName + ' ist gesperrt und steht ab jetzt unter „Gesperrte Nutzer“ — dort auch wieder freischaltbar.');
        // reloadUsers() statt fetchUser(): behält einen laufenden Suchbegriff
        // bei, siehe Kommentar an der Methode.
        _this.reloadUsers();
        _this.banDialog = false;
      }).catch(function(error){
        _this.onError(error);
      })
    },
    openUnbanUser(user) {
      this.editUser = user;
      this.unbanDialog = true;
    },
    unbanUser() {
      let _this = this;

      // Siehe banUser(): dieselbe fehlende Prüfung. Zusätzlich setzt das
      // Backend hier nur Konten mit status DEACTIVE (2) zurück auf ACTIVE —
      // ein Konto mit dem ungültigen Wert 0 (siehe Fund zum Status-Feld oben)
      // wurde bisher gar nicht gefunden und meldete trotzdem denselben
      // stillschweigenden "Erfolg".
      const body = { userId: this.editUser._id };
      const freigegebenerName = this.editUser.userName || 'Das Konto';
      this.$axios.post('/user/unban/', body).then(function(response){
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        // Wie bei banUser(): eine geglückte Freischaltung war bisher nur
        // daran zu erkennen, dass der Dialog zuging.
        _this.$noty.success(freigegebenerName + ' ist wieder freigeschaltet.');
        // reloadUsers() statt fetchUser(): behält einen laufenden Suchbegriff
        // bei, siehe Kommentar an der Methode.
        _this.reloadUsers();
        _this.unbanDialog = false;
      }).catch(function(error){
        _this.onError(error);
      })
    },
    setTimePicker(timeSpan) {
      console.log(timeSpan);
           let currentId = 'dropdown' + this.currentTimeSpan;
           let newId = 'dropdown' + timeSpan;

           document.getElementById(currentId).classList.remove('active');
           document.getElementById(newId).classList.add('active');

           this.currentTimeSpan = timeSpan;
           this.setCurrentTimeSpan(timeSpan);
       },
    setCurrentTimeSpan(timeSpan) {
      this.currentTimeSpan = timeSpan;
      if(this.userTab == 'tab-1') {
        this.fetchUser();
      } else {
        this.fetchUserPerCountry();
      }

    },
    getCurrentTimeSpan() {
      let time = -1;
      if(this.currentTimeSpan == 'Today') {
          time = 1;
      } else if (this.currentTimeSpan == 'LastWeek') {
          time = 7;
      } else if (this.currentTimeSpan == 'LastMonth') {
          time = 30;
      } else if (this.currentTimeSpan == 'AllTime') {
          time = -1;
      }

      return time;
    },
    /** Sprechblase mit Name und Ort öffnen. */
    openMapUser(m) {
      const pos = { lat: m.location.coordinates[1], lng: m.location.coordinates[0] };
      this.center = pos;
      this.mapInfo = {
        open: true,
        position: pos,
        userName: m.userName || 'Unbekannt',
        city: m.city || '',
        country: m.country || '',
      };
    },
    fetchUserPerCountry() {
      // WAR FALSCH: Dieser Aufruf hatte gar keinen .catch — ein Fehler blieb
      // vollständig unbehandelt (unhandled promise rejection). Die Karte im
      // Reiter "Map" wäre bei einem Fehlschlag einfach leer geblieben.
      this.$axios.get('/user/country/' + this.getCurrentTimeSpan()).then((response) => {
        this.usersByCountry = response.data.data;
      }).catch(this.onError);
    },
    handleTabChange(tab) {
      if(tab == '#tab-2') {
        this.setTimePicker('AllTime');
        this.fetchUserPerCountry();
      }
    },
    sendNewVerifyMail(editUser) {
      const body = {
        _id: editUser._id,
        email: editUser.email
      }
      // WAR FALSCH: Der Erfolgszweig zeigte "E-Mail versendet" ungeprüft an.
      // Der Server antwortet bei "Benutzer wurde nicht gefunden" mit HTTP 200
      // und success:false (respondFailure) — das landete bisher unbemerkt im
      // Erfolgszweig, obwohl gar nichts verschickt wurde.
      this.$axios.post('/sendValidationEmail', body, { headers: { language: editUser.language }}).then((response) => {
        if (response.data != null && response.data.success === false) {
          this.onError(response.data);
          return;
        }
        this.$noty.success("E-Mail versendet");
      }).catch((error) => {
        // WAR FALSCH: $showErrorWithMessage(error) zeigt error.message eines
        // Axios-Fehlers an — das ist der technische englische Text ("Request
        // failed with status code 500") mitten in einer deutschen Oberfläche.
        // onError nimmt die Meldung des Servers, wenn es eine gibt, und sonst
        // den deutschen Standardtext; 401/403 bleiben der zentralen Behandlung
        // in main.js überlassen.
        this.onError(error);
      });
    }
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

